var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("reports-header-tabs", {
        attrs: { hideTabs: _vm.hideTabs, permissions: _vm.permissions },
      }),
      _c("router-view", {
        attrs: { userRoleId: _vm.roleId },
        on: { hideTabs: _vm.displayTabs },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }